// Firebase Phone Auth (SMS OTP) used ONLY to verify possession of the fixed
// Brugo owner number before setting the profile password. Runs on a SEPARATE
// Firebase app instance so it never disturbs the signed-in admin session.
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber, signOut } from "firebase/auth";

export const PROFILE_OTP_PHONE = "+919999381210";

const cfg = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const otpApp = getApps().find((a) => a.name === "otp") || initializeApp(cfg, "otp");
const otpAuth = getAuth(otpApp);

let verifier = null;
let confirmation = null;

export async function sendProfileOtp(containerId = "recaptcha-container") {
  // Always start from a clean verifier so a previous failed/half-solved
  // reCAPTCHA can never wedge a retry ("reCAPTCHA already rendered").
  resetOtp();
  verifier = new RecaptchaVerifier(otpAuth, containerId, { size: "invisible" });
  await verifier.render();
  confirmation = await signInWithPhoneNumber(otpAuth, PROFILE_OTP_PHONE, verifier);
  return true;
}

export async function verifyProfileOtp(code) {
  if (!confirmation) throw new Error("Please request an OTP first");
  const cred = await confirmation.confirm(code);
  const idToken = await cred.user.getIdToken();
  try { await signOut(otpAuth); } catch (e) { /* keep admin session intact */ }
  confirmation = null;
  return idToken;
}

export function resetOtp() {
  try { verifier && verifier.clear(); } catch (e) {}
  verifier = null;
  confirmation = null;
}

export function otpErr(e) {
  const c = e?.code || "";
  if (c.includes("captcha")) return "reCAPTCHA check failed — reload and try again";
  if (c.includes("invalid-app-credential") || c.includes("unauthorized-domain")) return "This domain isn't authorised for Phone Auth in Firebase Console (Authentication → Settings → Authorized domains)";
  if (c.includes("invalid-verification-code")) return "Incorrect OTP";
  if (c.includes("too-many-requests")) return "Too many attempts — try again later";
  return e?.message || "OTP failed";
}
